module.exports = __webpack_public_path__ + "img/imgbanner2.57ed0195.png";